export default __webpack_public_path__ + "static/media/techspace3.8366cfa6.PNG";